import React, { useState } from "react";
import ExpensesMain from "./ExpensesMain";
import ExpenseDashboard from "./ExpenseDashboard";

const SwitchExpense = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return (
          <div>
            <ExpenseDashboard />
          </div>
        );

      case 2:
        return (
          <div>
            <ExpensesMain />
          </div>
        );

      default:
        return (
          <div>
            <ExpenseDashboard />
          </div>
        );
    }
  }

  return (
    <>
      <div className="p-8">
        <div className="grid grid-cols-5 bg-white rounded-lg mb-6 border overflow-hidden">
          <div
            onClick={() => setStep(1)}
            className={`iskool-tab-item ${
              step === 1 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Dashboard</div>
          </div>
          <div
            onClick={() => setStep(2)}
            className={`iskool-tab-item ${
              step === 2 ? "bg-gray-600 text-white shadow" : ""
            }`}
          >
            <div className="text-lg">Expenses List</div>
          </div>
        </div>
        <div>
          <div>{switchTab()}</div>
        </div>
      </div>
    </>
  );
};

export default SwitchExpense;
